import { Link } from "react-router-dom"
import { SocialIcon } from 'react-social-icons'
import './footer.css'
  //will probably migrate the Links here to separate button components
function footer() {
  return(

    <div className="footerDiv">
      <table>
        <tr>
          <th style={{margin:"auto"}}>
            <div style={{width:"40vw"}}>
              <p>
                Copyright &copy; Joseph A. E. Fleming VI, 2025. All rights reserved.
              </p>
              <ul style={{listStyleType:"none"}}>
                <li>
                  <Link to="/">Home Page</Link>
                </li><li>
                  <Link to="/contact">Contact Page</Link>
                </li><li>
                  <Link to="/about">About Us Page</Link>
                </li><li>
                  <Link to="/services">Services Page</Link>
                </li>
              </ul>
            </div>
          </th>
          <th>
            <div style={{width:"40vw"}}>
              <table style={{margin:"auto"}}>
                <tr>
                  <th>
                    Email:
                  </th>
                  <th>
                    flemingandsonshomeimprovement@gmail.com
                  </th>
                </tr>
                <tr>
                  <th>
                    Phone:
                  </th>
                  <th>
                    (765) 717-6690
                  </th>
                </tr>
                <tr>
                  <th>
                    Hours:
                  </th>
                  <th>
                    7AM-7PM, 7 days/week
                  </th>
                </tr>
              </table>
              <SocialIcon url="www.facebook.com" href="https://www.facebook.com/flemingandsonshomeimprovement"/>
            </div>
          </th>
        </tr>
      </table>
    </div>
  )
}

export default footer